import {
  Box,
  type BoxProps,
  HStack,
  Popover,
  PopoverArrow,
  PopoverBody,
  PopoverContent,
  PopoverTrigger,
  Portal,
  Stack,
  Text,
} from "@chakra-ui/react";
import { Avatar } from "@components/ui-kit/avatar";
import type { UserToolTip_UserFragmentFragment } from "@src/__generated__/urql-graphql";
import { Icon } from "@src/components/ui-kit/Icon";
import type React from "react";
import type { FunctionComponent } from "react";

// extend BoxProps to support AvatarGroup (https://github.com/chakra-ui/chakra-ui/issues/3329)
export interface UserTooltipProps extends BoxProps {
  user: UserToolTip_UserFragmentFragment | undefined;
  isDisabled?: boolean;
}

export const UserTooltip: FunctionComponent<
  React.PropsWithChildren<UserTooltipProps>
> = ({ user, children, isDisabled = false, ...props }) => {
  if (!user) return null;
  if (!user.profile || !user.team) return children;
  return (
    <Popover isLazy placement="top-start" trigger="hover">
      <PopoverTrigger>
        <Box {...props}>{children}</Box>
      </PopoverTrigger>

      {!isDisabled && (
        <Portal>
          <PopoverContent>
            <PopoverArrow />
            <PopoverBody p="3">
              <HStack align="start" spacing="3">
                <Avatar
                  name={user.full_name}
                  colorScheme={user.profile?.hex_color}
                  size="lg"
                  src={user.image?.urls.thumbnail}
                />
                <Stack>
                  <Text fontSize="xs">
                    <b>{user.codename}</b> {user.full_name}
                  </Text>
                  <HStack>
                    <Icon name="briefcase-01" w="4" h="4" color="grey.500" />
                    <Text fontSize="xs">
                      {user.profile.defaultWorktype.title} ({user.team.name})
                    </Text>
                  </HStack>
                </Stack>
              </HStack>
            </PopoverBody>
          </PopoverContent>
        </Portal>
      )}
    </Popover>
  );
};
